/* Phones: a 4×2 grid (`--strip-columns`, per site: miami's seven are
   4 + 3) whose 1 px gaps show the darker ground as dividers — tighter than the
   Mobile board's 3×3 (smaller icon, padding and type), so the strip doesn't
   take a whole screen. */
.band {
  padding: 10px 12px;
  background: var(--band);
  border-bottom: 1px solid var(--border);
}

.grid {
  max-width: var(--container);
  margin: 0 auto;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(var(--strip-columns, 4), minmax(0, 1fr));
  gap: 1px;
  background: var(--border-strong);
  box-sizing: border-box;
}

.cell {
  display: flex;
  background: var(--band);
}

/* Four columns with one short of two rows (miami's seven): the last tile takes
   the empty cell too, so no hole of the darker ground shows. */
.cell:last-child:nth-child(4n + 3) {
  grid-column: span 2;
}

.link {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 9px 2px;
  text-align: center;
  font-size: 10.5px;
  font-weight: 500;
  line-height: 1.25;
  color: var(--text);
}

.icon {
  width: 22px;
  height: 22px;
}

.label {
  white-space: pre-line;
  overflow-wrap: anywhere;
}

/* Main board: one row of equal columns, however many tiles the site has (a
   floor on their width wrapped dubai's eight at 1024 px), a thin rule between
   them. */
@media (min-width: 1024px) {
  .band {
    padding: 0;
  }

  .grid {
    padding: 22px var(--gutter);
    grid-template-columns: none;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
    gap: 0;
    background: none;
  }

  .cell:last-child:nth-child(4n + 3) {
    grid-column: auto;
  }

  .cell + .cell {
    border-left: 1px solid var(--border-strong);
  }

  .link {
    gap: 12px;
    padding: 12px 8px;
    font-size: 13px;
    line-height: 1.35;
  }

  .icon {
    width: 34px;
    height: 34px;
  }
}
